export default __webpack_public_path__ + "bccf7302c2fd8513f9ae19cd3fb1bb68.gif";